module.exports = __webpack_public_path__ + "img/bigCenter.0a1dabda.png";